import React from "react";
import WindowEvent from "./";

export default props => <WindowEvent type="resize" {...props} />;
